import React from "react";
import PropTypes from "prop-types";
import TextInfo, {
  TEXT_COLOR,
  TEXT_SEGMENT,
} from "@/bit/components/components.text";
import Image from "@/bit/components/components.c-image";
import Icon from "@/bit/components/components.icon-glyph";
import CustomLink from "@/bit/components/components.custom-link";
import getColor from "@gcloud-npm/utils.enums.colors";

export const COMPONENT_NAME = "PageIntro";
export { TEXT_COLOR, TEXT_SEGMENT };

const PageIntro = (props) => {
  const { cmsHandler } = props;

  const hasImg = !!(props["cms-atom-image-1"]?.src || cmsHandler);
  const hasLink = !!(props["cms-atom-link-1"]?.href || cmsHandler);
  const color = props.backgroundColor || "white";
  const backgroundColor = getColor(color);

  const renderImage = () => (
    <Image
      {...props["cms-atom-image-1"]}
      cmsHandler={cmsHandler}
      fill={false}
      width={120}
      height={120}
    />
  );

  return (
    <>
      {cmsHandler && (
        <span
          className={"element-editable block"}
          onClick={cmsHandler
              ? () =>
                  cmsHandler({
                    ...props,
                    name: "cms-block.page-intro",
                  })
              : null
          }
        >
          <Icon id="lapiz-m" height={15} color="white" />
        </span>
      )}
      <div className="page-intro" style={{ backgroundColor: backgroundColor }}>
        <div className="container">
          <div
            className={`page-intro-content--layout-${hasImg ? "img" : "default"}`}
          >
            <div className="main-content">
              <div className="page-intro-text">
                <TextInfo
                  {...props["cms-atom-text-1"]}
                  cmsHandler={cmsHandler}
                />
                <TextInfo
                  {...props["cms-atom-text-2"]}
                  cmsHandler={cmsHandler}
                  className="desktop-description"
                />
              </div>
              {hasImg && (
                <div className="page-intro-img">
                  {hasLink ? (
                    <CustomLink
                      {...props["cms-atom-link-1"]}
                      cydata="PageIntro CustomLink"
                      cmsHandler={cmsHandler}
                    >
                      {renderImage()}
                    </CustomLink>
                  ) : (
                    renderImage()
                  )}
                </div>
              )}
            </div>
            <div className="secondary-content">
              <TextInfo
                {...props["cms-atom-text-2"]}
                cmsHandler={cmsHandler}
                className="mobile-description"
              />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`.page-intro {
  margin-top: 1rem;
  .container {
    .page-intro-content--layout-img {
      padding: 1rem 0rem 1rem 0rem;
      .main-content {
        display: flex;
        gap: 1rem;
        .page-intro-text {
          display: flex;
          gap: 1rem;
          flex-direction: column;
          flex: 1;
        }
        .page-intro-img {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 20%;
          position: relative;
        }
        :global(.desktop-description) {
          display: none;
        }
      }
      .secondary-content {
        :global(.mobile-description) {
          margin-top: 2rem;
        }
      }
    }
    .page-intro-content--layout-default {
      display: flex;
      flex-direction: column;
      padding: 0.3rem 0rem 0.3rem 0rem;
      .page-intro-text {
        display: flex;
        gap: 0.5rem;
        flex-direction: column;
        flex: 1;
      }
      .secondary-content {
        display: none;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .page-intro {
    margin-top: 1rem;
    .page-intro-content--layout-img {
      align-items: center;
      :global(.desktop-description) {
        display: flex !important;
        flex-direction: column;
      }
    }
    .container {
      :global(.mobile-description) {
        display: none;
      }
    }
  }
}
`}</style>
    </>
  );
};

PageIntro.propTypes = {
  /**
   * {
   *  "info": "Color de fondo del bloque",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo del bloque"
   * }
   */
  backgroundColor: PropTypes.string,
};

PageIntro.defaultProps = {
  backgroundColor: "",
};

export default PageIntro;
